import { render, staticRenderFns } from "./ModalRecalcularImpostosEAlugueis.vue?vue&type=template&id=3a6bc66a"
import script from "./ModalRecalcularImpostosEAlugueis.vue?vue&type=script&lang=ts"
export * from "./ModalRecalcularImpostosEAlugueis.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports